import { NavigateFunction } from "react-router-dom";
import IconUploadFileSolid from "@/assets/images/icon-upload-file-solid.svg?react";
import IconUploadFileOutline from "@/assets/images/icon-upload-file-outline.svg?react";
import IconTemplateOutline from "@/assets/images/icon-template-outline.svg?react";
import IconTemplateSolid from "@/assets/images/icon-template-solid.svg?react";
import IconCampaignOutline from "@/assets/images/icon-campaign-outline.svg?react";
import IconCampaignSolid from "@/assets/images/icon-campaign-solid.svg?react";
const SidebarItems = (navigate: NavigateFunction) => {
  return [
    {
      onClick: () => navigate("/upload"),
      label: "Upload",
      icon: <IconUploadFileOutline />,
      iconActive: <IconUploadFileSolid />,
      activeUrl: ["upload"],
    },
    {
      onClick: () => navigate("/templates"),
      label: "Templates",
      icon: <IconTemplateOutline />,
      iconActive: <IconTemplateSolid />,
      activeUrl: ["templates"],
    },
    {
      onClick: () => navigate("/campaigns"),
      label: "Campaigns",
      icon: <IconCampaignOutline />,
      iconActive: <IconCampaignSolid />,
      activeUrl: ["campaigns"],
    },
  ];
};

export default SidebarItems;
